import { render } from "./NotificationStatus.vue?vue&type=template&id=f38ecd22&scoped=true"
import script from "./NotificationStatus.vue?vue&type=script&lang=js"
export * from "./NotificationStatus.vue?vue&type=script&lang=js"

import "./NotificationStatus.vue?vue&type=style&index=0&id=f38ecd22&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38ecd22"]])

export default __exports__